import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface DeliveryBucketListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: DeliveryBucketListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "uniqueId",
    sortOrder: "asc"
};

export const useDeliveryBucketListingFilters = () => {
    const getDefaultFilters = (filters: DeliveryBucketListingFilters): DeliveryBucketListingFilters => {
        return { ...filters };
    };

    const generatedDefaultFilters = getDefaultFilters(defaultFilters);
    const filtersService = useMemo(() => listFiltersService<DeliveryBucketListingFilters>(generatedDefaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<DeliveryBucketListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: DeliveryBucketListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: DeliveryBucketListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: DeliveryBucketListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    return {
        filters,
        setPage,
        setPageSize,
        setSort
    };
};
